var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"fluid":""}},[_c('v-btn',{on:{"click":function($event){return _vm.goTo('campo')}}},[_vm._v(" Campo ")]),_c('v-btn',{on:{"click":function($event){return _vm.goTo('moderador')}}},[_vm._v(" Moderação ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }